import React from 'react';
import { Redirect } from 'react-router-dom';
import { checkPermission, Constants } from 'utils';

const Home = () => {
	if (checkPermission(Constants.MODULES.MODERATORS,'read')) {
		return <Redirect to="/admin/moderators" />
	}
	else if (checkPermission(Constants.MODULES.SERVICES,'read')) {
		return <Redirect to="/admin/services" />
	}
	else if (checkPermission(Constants.MODULES.QUOTES,'read')) {
		return <Redirect to="/admin/quotes" />
	}
	else if (checkPermission(Constants.MODULES.OPERATORS,'read')) {
		return <Redirect to="/admin/operators" />
	}
	else if (checkPermission(Constants.MODULES.CLIENTS,'read')) {
		return <Redirect to="/admin/clients" />
	}

	return null;
}

export default Home;